var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.43,
    height: 38.56,
    viewBox: "0 0 215.43 38.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 215.43,
    height: 38.56,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-141 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(141 31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34180",
    "data-name": "Path 34180",
    d: "M178.191,56.119h0Z",
    transform: "translate(-120.933 -38.086)",
    fill: "#55cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34181",
    "data-name": "Path 34181",
    d: "M119.157,56.165V73.03l18.987-1.079v-14.5Z",
    transform: "translate(-80.868 -38.118)",
    fill: "#55cece"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34182",
    "data-name": "Path 34182",
    d: "M24.859,1.079V17.038l10.884.74A9.71,9.71,0,0,1,55.06,16.737L65.7,17.46V0Z",
    transform: "translate(-16.871)",
    fill: "#f5b85b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34183",
    "data-name": "Path 34183",
    d: "M3.71,56.119H0V73L18.864,71.92V57.149Z",
    transform: "translate(0 -38.086)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34184",
    "data-name": "Path 34184",
    d: "M206.788,62.391l-2.9,2.67v3.513h-1.663V51.2h1.663V62.977l7.354-6.722H213.3l-5.27,5.035,5.761,7.284h-2.038Z",
    transform: "translate(-137.241 -34.745)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34185",
    "data-name": "Path 34185",
    d: "M243.9,53.21a1.15,1.15,0,0,1-.351-.843,1.123,1.123,0,0,1,.351-.82,1.178,1.178,0,0,1,.867-.352,1.2,1.2,0,0,1,.867.34,1.085,1.085,0,0,1,.351.808,1.226,1.226,0,0,1-2.084.867m.023,3.045h1.663V68.574h-1.663Z",
    transform: "translate(-165.288 -34.745)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34186",
    "data-name": "Path 34186",
    d: "M273.555,67.995a5.261,5.261,0,0,1,1.37,3.923v7.144h-1.663V72.082a4.086,4.086,0,0,0-.96-2.928,3.609,3.609,0,0,0-2.74-1.007,4.21,4.21,0,0,0-3.15,1.183,4.467,4.467,0,0,0-1.159,3.267v6.464H263.59V66.742h1.593v2.272a4.625,4.625,0,0,1,1.886-1.745,6.036,6.036,0,0,1,2.8-.621,5.035,5.035,0,0,1,3.689,1.347",
    transform: "translate(-178.89 -45.232)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34187",
    "data-name": "Path 34187",
    d: "M320.969,51.2V68.575h-1.592V66.139a5.066,5.066,0,0,1-1.979,1.9,5.8,5.8,0,0,1-2.775.656,6.249,6.249,0,0,1-3.138-.8,5.687,5.687,0,0,1-2.2-2.225,7.05,7.05,0,0,1,0-6.511,5.612,5.612,0,0,1,2.2-2.213,6.328,6.328,0,0,1,3.138-.785,5.829,5.829,0,0,1,2.7.621,5.125,5.125,0,0,1,1.979,1.815V51.2Zm-3.876,15.422a4.242,4.242,0,0,0,1.639-1.7,5.557,5.557,0,0,0,0-5.012,4.245,4.245,0,0,0-1.639-1.7,4.89,4.89,0,0,0-4.684,0,4.243,4.243,0,0,0-1.639,1.7,5.558,5.558,0,0,0,0,5.012,4.24,4.24,0,0,0,1.639,1.7,4.89,4.89,0,0,0,4.684,0",
    transform: "translate(-209.36 -34.746)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34188",
    "data-name": "Path 34188",
    d: "M369.141,73.416h-10.3a4.4,4.4,0,0,0,1.475,3.1,4.9,4.9,0,0,0,3.373,1.183,5.312,5.312,0,0,0,2.108-.41,4.6,4.6,0,0,0,1.663-1.206l.937,1.077a5.272,5.272,0,0,1-2.049,1.5,6.931,6.931,0,0,1-2.7.515,6.84,6.84,0,0,1-3.361-.808,5.822,5.822,0,0,1-2.284-2.237,6.373,6.373,0,0,1-.82-3.232,6.6,6.6,0,0,1,.785-3.232,5.683,5.683,0,0,1,2.155-2.225,6.02,6.02,0,0,1,3.08-.8,5.957,5.957,0,0,1,3.068.8,5.649,5.649,0,0,1,2.131,2.213,6.665,6.665,0,0,1,.772,3.244Zm-8.935-4.2a4.46,4.46,0,0,0-1.37,2.963h8.735a4.463,4.463,0,0,0-1.37-2.963,4.524,4.524,0,0,0-6,0",
    transform: "translate(-242.402 -45.232)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34189",
    "data-name": "Path 34189",
    d: "M407.667,67.281a5.928,5.928,0,0,1,2.869-.632v1.616l-.4-.023a3.934,3.934,0,0,0-3.045,1.194,4.757,4.757,0,0,0-1.1,3.349v6.277H404.33V66.743h1.592v2.412a4.025,4.025,0,0,1,1.745-1.873",
    transform: "translate(-274.406 -45.233)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34190",
    "data-name": "Path 34190",
    d: "M441.5,56.594a5.808,5.808,0,0,1,2.26,2.272,7.493,7.493,0,0,1,0,6.815,5.805,5.805,0,0,1-2.26,2.272,6.422,6.422,0,0,1-3.2.808,4.845,4.845,0,0,1-3.958-1.639v1.452h-3.49V51.2h3.654v6.113a4.868,4.868,0,0,1,3.794-1.522,6.421,6.421,0,0,1,3.2.808m-1.522,8.221a4.032,4.032,0,0,0,0-5.082,3.28,3.28,0,0,0-4.614,0,4.032,4.032,0,0,0,0,5.082,3.28,3.28,0,0,0,4.614,0",
    transform: "translate(-292.41 -34.745)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34191",
    "data-name": "Path 34191",
    d: "M485.678,65.951a6.567,6.567,0,0,1,2.565-.468v3.373q-.609-.047-.82-.047a3.348,3.348,0,0,0-2.459.878,3.547,3.547,0,0,0-.89,2.635V78.27H480.42v-12.6h3.489v1.663a4.065,4.065,0,0,1,1.768-1.382",
    transform: "translate(-326.046 -44.441)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34192",
    "data-name": "Path 34192",
    d: "M510.06,51.407a1.983,1.983,0,0,1,0-2.9,2.318,2.318,0,0,1,1.639-.585,2.374,2.374,0,0,1,1.639.562,1.8,1.8,0,0,1,.633,1.405,1.989,1.989,0,0,1-.633,1.511,2.289,2.289,0,0,1-1.639.6,2.318,2.318,0,0,1-1.639-.585m-.187,2.342h3.653v12.6h-3.653Z",
    transform: "translate(-345.732 -32.52)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34193",
    "data-name": "Path 34193",
    d: "M542.976,51.2V68.574h-3.49V67.122a4.817,4.817,0,0,1-3.935,1.639,6.54,6.54,0,0,1-3.22-.8,5.7,5.7,0,0,1-2.26-2.272,7.539,7.539,0,0,1,0-6.839,5.7,5.7,0,0,1,2.26-2.272,6.547,6.547,0,0,1,3.22-.8,4.8,4.8,0,0,1,3.771,1.522V51.2Zm-4.5,13.619a3.991,3.991,0,0,0,0-5.082,3.279,3.279,0,0,0-4.614,0,3.992,3.992,0,0,0,0,5.082,3.279,3.279,0,0,0,4.614,0",
    transform: "translate(-359.187 -34.745)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34194",
    "data-name": "Path 34194",
    d: "M592.748,65.669V76.162a6.736,6.736,0,0,1-1.8,5.153A7.448,7.448,0,0,1,585.675,83a13.181,13.181,0,0,1-3.466-.445,7.575,7.575,0,0,1-2.717-1.288l1.452-2.623a5.981,5.981,0,0,0,2.014,1.042,8.022,8.022,0,0,0,2.436.386,3.949,3.949,0,0,0,2.8-.855,3.407,3.407,0,0,0,.9-2.588v-.539a5.112,5.112,0,0,1-3.981,1.569,6.686,6.686,0,0,1-3.173-.761,5.8,5.8,0,0,1-2.283-2.143,6.438,6.438,0,0,1,0-6.37,5.8,5.8,0,0,1,2.283-2.143,6.686,6.686,0,0,1,3.173-.761,5,5,0,0,1,4.169,1.8V65.669Zm-4.532,8.139a3.165,3.165,0,0,0,0-4.473,3.364,3.364,0,0,0-2.377-.855,3.406,3.406,0,0,0-2.389.855,3.138,3.138,0,0,0,0,4.473,3.406,3.406,0,0,0,2.389.855,3.364,3.364,0,0,0,2.377-.855",
    transform: "translate(-392.822 -44.441)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34195",
    "data-name": "Path 34195",
    d: "M642.313,73h-9.532A2.967,2.967,0,0,0,634,74.851a4.034,4.034,0,0,0,2.389.679,4.833,4.833,0,0,0,1.745-.293,4.222,4.222,0,0,0,1.417-.925l1.944,2.108a6.533,6.533,0,0,1-5.2,2.038,8.227,8.227,0,0,1-3.771-.831,6.092,6.092,0,0,1-2.53-2.307,6.357,6.357,0,0,1-.89-3.349,6.442,6.442,0,0,1,.878-3.337,6.154,6.154,0,0,1,2.413-2.319,7.472,7.472,0,0,1,6.78-.035,5.819,5.819,0,0,1,2.353,2.284,6.807,6.807,0,0,1,.855,3.454q0,.07-.07.984m-8.548-4.052a2.991,2.991,0,0,0-1.03,1.921h6.206a3.022,3.022,0,0,0-1.031-1.909,3.081,3.081,0,0,0-2.061-.714,3.146,3.146,0,0,0-2.084.7",
    transform: "translate(-426.953 -44.441)",
    fill: "#2e90d8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a1264d5bb66c3f0f562f12f6f94f369.svg";
export { ForwardRef as ReactComponent };